import { useQuery, QueryHookOptions } from '@apollo/client';

import { GET_AFFILIATE_OFFER_CONVERSION_HISTORY_QUERY_BY_ID } from '../queries/getOfferAffiliateConversionHistoryByIdQuery';
import { GetOfferAffiliateConversionHistoryById, GetOfferAffiliateConversionHistoryByIdVariables } from '../queries/types/GetOfferAffiliateConversionHistoryById';

type TOptions = QueryHookOptions<GetOfferAffiliateConversionHistoryById, GetOfferAffiliateConversionHistoryByIdVariables>;

export const useGetOfferAffiliateConversionHistoryById = (options: TOptions = {}) => useQuery<GetOfferAffiliateConversionHistoryById, GetOfferAffiliateConversionHistoryByIdVariables>(GET_AFFILIATE_OFFER_CONVERSION_HISTORY_QUERY_BY_ID, options);
